module.exports = __webpack_public_path__ + "img/head_2.6f05ecd3.jpg";